import clsx from 'clsx';
import { useMemo } from 'react';
import useAssetMetadataQuery from '../hooks/useAssetMetadataQuery';
import KittyImageLayers from './KittyImageLayers';
import Spinner from './Spinner';
import StyledLink from './StyledLink';

const KittySwapHistory = ({ assetId }) => {
  const { data } = useAssetMetadataQuery(assetId, true);
  const swapHistory = useMemo(() => (data ? [...data].reverse() : []), [data?.length]);

  if (swapHistory.length < 2) return null;

  return (
    <div className='flex flex-col gap-4 bg-gray-800 p-4 rounded-lg w-full'>
      <div className='flex items-center gap-2 text-gray-400'>
        <div className='w-4 h-4'>
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
            <path
              d='M406.6 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.5-62.5-163.8-62.5-226.3 0L125.5 160l34.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48.3 224c0 0 0 0 0 0l-.4 0c-17.7 0-32-14.3-32-32l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 35.2L97.4 97.6c87.5-87.5 229.3-87.5 316.8 0c24.4 24.4 42.1 53.1 52.9 83.7c5.9 16.7-2.9 34.9-19.5 40.8s-34.9-2.9-40.8-19.5zm66.1 86.6c5 1.5 9.8 4.2 13.7 8.2c4 4 6.7 8.9 8.1 14c.3 1.2 .6 2.5 .8 3.8c.3 1.7 .4 3.4 .4 5.1l0 111.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-35.1-17.6 17.5c0 0 0 0 0 0c-87.5 87.4-229.3 87.4-316.7 0C73 390 55.3 361.3 44.5 330.6c-5.9-16.7 2.9-34.9 19.5-40.8s34.9 2.9 40.8 19.5c7.7 21.8 20.2 42.3 37.8 59.8c62.5 62.5 163.8 62.5 226.3 0l.1-.1L386.1 352l-34.4 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l111.6 0c1.6 0 3.2 .1 4.8 .3s3.1 .5 4.6 1z'
              fill='currentColor'
            />
          </svg>
        </div>
        <div className='flex items-center gap-2'>
          <h2 className='text-gray-400 font-medium text-lg'>Swap History</h2>
          <StyledLink href='/trait-swapper' link>
            Swap Traits
          </StyledLink>
        </div>
      </div>

      <div className='flex flex-wrap gap-4'>
        {swapHistory.map((item, index) => (
          <KittySwapHistoryItem key={index} item={item} last={index === swapHistory.length - 1} />
        ))}
      </div>
    </div>
  );
};

const KittySwapHistoryItem = ({ item, last }) => {
  return (
    <div className='flex items-center gap-4'>
      <div className='flex items-center gap-4 w-full w-[125px] h-[125px] md:w-[200px] md:h-[200px] relative'>
        <div className='aspect-square rounded-lg bg-gray-950 w-full'>
          <div className='absolute inset-0 w-full h-full flex items-center justify-center'>
            <Spinner className='w-12 h-12' />
          </div>
          <KittyImageLayers metadata={item} className='rounded-lg w-full h-full object-cover absolute' />
        </div>
      </div>
      <div className={clsx('w-6 h-6 flex items-center justify-center text-white', last && 'opacity-0')}>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' className='w-6 h-6'>
          <path
            d='M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z'
            fill='currentColor'
          />
        </svg>
      </div>
    </div>
  );
};

export default KittySwapHistory;
